/**
 * A1 screens embedded under Service Desk (`/sd/...`) should send `is_servicedesk`
 * so APIs return Service Desk–scoped data. Main A1 routes (no `/sd` prefix) omit it.
 */
export function isServiceDeskHostPath(): boolean {
  if (typeof window === "undefined") return false;
  return window.location.pathname.startsWith("/sd");
}

export function mergeServiceDeskParams<T extends Record<string, any>>(
  params: T
): T & { is_servicedesk?: boolean } {
  if (!isServiceDeskHostPath()) return params;
  return { ...params, is_servicedesk: true };
}

export function mergeServiceDeskBody<T extends object>(
  body: T
): T & { is_servicedesk?: boolean } {
  if (!isServiceDeskHostPath()) return body as T & { is_servicedesk?: boolean };
  return { ...body, is_servicedesk: true };
}

/** For APIs built with manual query strings (e.g. `/import-data/?page=1`). */
export function appendServiceDeskQuery(url: string): string {
  if (!isServiceDeskHostPath()) return url;
  return url.includes("?") ? `${url}&is_servicedesk=true` : `${url}?is_servicedesk=true`;
}
